// src/pages/appointments/details/AppointmentMissedDialog.jsx
import React from "react";
import { useLanguage } from "@/contexts/LanguageContext.jsx";

export default function AppointmentMissedDialog({
  open,
  title,
  description,
  closeText,
  onClose,
  maxWidthClassName = "max-w-[380px]",
}) {
  const { t } = useLanguage();
  if (!open) return null;

  const resolvedTitle =
    title || t("appointments.missedDialog.title", "Missed appointment");
  const resolvedDescription =
    description ||
    t(
      "appointments.missedDialog.description",
      "Participants for this appointment did not arrive within the booked time window. This appointment is no longer available. If you still need care, please choose a new available time and make a fresh booking.",
    );
  const resolvedCloseText =
    closeText || t("common.actions.close", "Close");

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-black/35" onClick={onClose} />

      <div
        className={[
          "relative w-full rounded-[28px] bg-[rgb(var(--clr-surface-cont-highest))] shadow-[0_12px_40px_rgba(2,6,23,0.18)] overflow-hidden",
          maxWidthClassName,
        ].join(" ")}
        role="dialog"
        aria-modal="true"
      >
        <div className="px-6 pt-6 pb-5 text-center">
          <div className="text-headline-small text-on-surface">{resolvedTitle}</div>
          <div className="mt-4 text-body-medium text-on-surface-var">{resolvedDescription}</div>
        </div>

        <div className="px-5 pb-5">
          <button
            type="button"
            className="
              h-12 w-full rounded-[12px]
              bg-[rgb(var(--afrimed-primary))]
              text-[rgb(var(--afrimed-on-primary))]
              text-label-large
            "
            onClick={onClose}
          >
            {resolvedCloseText}
          </button>
        </div>
      </div>
    </div>
  );
}
